import styled, { css } from 'styled-components';
import { typography } from 'styled-system';
import { color } from '@magalu/stereo-ui-styles';
import Text from '../../atoms/Text';
export const Wrapper = styled.div`
  display: flex;
  align-items: center;
`;
export const Label = styled(Text).attrs(props => ({
  fontSize: [props.fontSize || 0, 1, 1],
  fontWeight: 'regular',
  as: 'span',
  color: 'text.scratched'
}))`
  display: inline-block;
  margin-left: 5px;
  ${props => props.format === 'label' && css`
      margin-bottom: 2px;
    `}
  ${typography}
  ${color}
`;